import { useContext } from 'react'
import { CampaignContext } from '../store/CampaignContext'

export const useCurrentCampaign = () => {
    return useContext(CampaignContext).currentCampaign
}
